
class FocusCertifsModal extends HTMLElement {
	constructor() {
		super()
		this.modalButtonOpen = document.querySelector('[data-focus-certifs-open]')
		this.modalButtonsClose = this.querySelectorAll('[data-focus-certifs-close]')

		this.init()
	}

	init() {

		// Open
		if (this.modalButtonOpen) {
			this.modalButtonOpen.addEventListener('click', (e) => {
				e.preventDefault()
				e.stopPropagation()
				this.openModal()
			})
		}

		// Close
		if (this.modalButtonsClose) {
			this.modalButtonsClose.forEach(btn => {
				btn.addEventListener('click', (e) => {
					e.preventDefault()
					e.stopPropagation()
					this.closeModal()
				})
			})
		}

	}

	openModal() {
		this.modalButtonOpen.setAttribute('aria-expanded', true)
		this.setAttribute('aria-hidden', false)
	}

	closeModal() {
		this.modalButtonOpen.setAttribute('aria-expanded', false)
		this.setAttribute('aria-hidden', true)
	}

}

customElements.get('focus-certifs-modal') || customElements.define('focus-certifs-modal', FocusCertifsModal)
